import React from "react";
import Hero from "./Hero";
import CountdownBar from "./CountdownBar";
import Prizes from "./Prizes";
import WinnersStage from "./WinnersStage";
import Leaderboard from "./Leaderboard";
import Steps from "./Steps";
import Rules from "./Rules";
import BottomCta from "./BottomCta";

const Competition = () => {
  return (
    <>
      <Hero />
      {/* Figma: top 732 / height 541 / gradient under hero seam */}
      <div className="competition-lower">
        <CountdownBar />
        <Prizes />
      </div>
      <WinnersStage />
      <Leaderboard />
      <Steps />
      <Rules />
      <BottomCta />
    </>
  );
};

export default Competition;
